module.exports = __webpack_public_path__ + "img/p62-award-certificate.8d1da383.jpg";